import React from 'react';
import { FilePdfOutlined, FileImageOutlined, FileTextOutlined, FileOutlined } from '@ant-design/icons';
import { Card } from 'antd';

const getFileExtension = (filename) => {
  if (!filename) return '';
  const parts = filename.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

const isImageFile = (filename) => {
  const ext = getFileExtension(filename);
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext);
};

const isPdfFile = (filename) => {
  return getFileExtension(filename) === 'pdf';
};

const DocumentThumbnail = ({ file, style = {} }) => {
  const { filename, presigned_url, size } = file;
  const isImage = isImageFile(filename);
  const isPdf = isPdfFile(filename);

  const defaultStyle = {
    width: '120px',
    height: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    cursor: 'pointer',
    overflow: 'hidden',
    ...style,
  };

  const getIconComponent = () => {
    if (isPdf) {
      return <FilePdfOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />;
    }
    const ext = getFileExtension(filename);
    if (['doc', 'docx', 'txt', 'rtf'].includes(ext)) {
      return <FileTextOutlined style={{ fontSize: '48px', color: '#1890ff' }} />;
    }
    return <FileOutlined style={{ fontSize: '48px', color: '#8c8c8c' }} />;
  };

  return (
    <a
      href={presigned_url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <div style={defaultStyle}>
        {isImage ? (
          <img
            src={presigned_url}
            alt={filename}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <div style={{ textAlign: 'center', padding: '8px' }}>
            {getIconComponent()}
            <div
              style={{
                marginTop: '8px',
                fontSize: '12px',
                color: '#595959',
                wordBreak: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {filename}
            </div>
          </div>
        )}
      </div>
      {size && (
        <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px', textAlign: 'center' }}>
          {Math.round(size / 1024)} KB
        </div>
      )}
    </a>
  );
};

export default DocumentThumbnail;
